class HeroSection extends HTMLElement {
  constructor() {
    super()

    const videoComponent = this.querySelector('hh-adaptive-video')
    if (videoComponent) {
      const videoElement = videoComponent.videoElement
      const host = videoComponent.getAttribute('host')
      const playBtn = this.querySelector('.hero-content__video-btn--play')
      const pauseBtn = this.querySelector('.hero-content__video-btn--pause')
      if (host == 'vimeo') {
        const player = new Vimeo(videoElement)

        playBtn.addEventListener('click', function () {
          pauseBtn.classList.remove('hidden')
          playBtn.classList.add('hidden')

          player.play()
        })

        pauseBtn.addEventListener('click', function () {
          playBtn.classList.remove('hidden')
          pauseBtn.classList.add('hidden')

          player.pause()
        })
      } else if (host == 'youtube') {
        const player = new YT.Player(videoElement, {
          events: {
            onReady: onPlayerReady,
          },
        })

        function onPlayerReady() {
          playBtn.addEventListener('click', function () {
            pauseBtn.classList.remove('hidden')
            playBtn.classList.add('hidden')

            player.playVideo()
          })

          pauseBtn.addEventListener('click', function () {
            playBtn.classList.remove('hidden')
            pauseBtn.classList.add('hidden')

            player.pauseVideo()
          })
        }
      }
    }
  }
}

if (customElements.get('hero-section') === undefined) {
  customElements.define('hero-section', HeroSection)
}
